

import { AuthGuard } from './AuthGuard';

interface ClientWrapperProps {
  children: React.ReactNode;
}

export function ClientWrapper({ children }: ClientWrapperProps) {
  return <AuthGuard>{children}</AuthGuard>;
}
